module.exports = [["true","Ja"]]


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/SingleChoise.json
// module id = 220
// module chunks = 0